const DISPOSABLE_DOMAINS = new Set([
  "tempmail.com",
  "temp-mail.org",
  "tempmail.org",
  "temp-mail.com",
  "tempmail.com",
  "tempmail.org",
  "10minutemail.com",
  "10minutemail.net",
  "10minutemail.org",
  "guerrillamail.com",
  "guerrillamail.net",
  "guerrillamail.org",
  "mailinator.com",
  "mailinator.net",
  "mailinator.org",
  "yopmail.com",
  "yopmail.net",
  "yopmail.org",
  "sharklasers.com",
  "sharklasers.net",
  "sharklasers.org",
  "trashmail.com",
  "trashmail.net",
  "trashmail.org",
  "dispostable.com",
  "dispostable.net",
  "dispostable.org",
  "fakeinbox.com",
  "fakeinbox.net",
  "fakeinbox.org",
  "getnada.com",
  "getnada.net",
  "getnada.org",
  "inboxclean.com",
  "inboxclean.net",
  "inboxclean.org",
  "jetable.com",
  "jetable.net",
  "jetable.org",
  "mailexpire.com",
  "mailexpire.net",
  "mailexpire.org",
  "meltmail.com",
  "meltmail.net",
  "meltmail.org",
  "mailnesia.com",
  "mailnesia.net",
  "mailnesia.org",
  "tempalias.com",
  "tempalias.net",
  "tempalias.org",
  "emailondeck.com",
  "emailondeck.net",
  "emailondeck.org",
  "spamgourmet.com",
  "spamgourmet.net",
  "spamgourmet.org",
  "deadaddress.com",
  "deadaddress.net",
  "deadaddress.org",
  "throwawaymail.com",
  "throwawaymail.net",
  "throwawaymail.org",
  "anonmail.net",
  "anonmail.org",
  "tempinbox.com",
  "tempinbox.net",
  "tempinbox.org",
  "maildrop.cc",
  "maildrop.dev",
  "maildrop.io",
  "maildrop.sh",
  "getairmail.com",
  "getairmail.net",
  "getairmail.org",
  "binkmail.com",
  "binkmail.net",
  "binkmail.org",
  "byomail.com",
  "byomail.net",
  "byomail.org",
  "chacmail.com",
  "chacmail.net",
  "chacmail.org",
  "dodgit.com",
  "dodgit.net",
  "dodgit.org",
  "dodgeit.com",
  "dodgeit.net",
  "dodgeit.org",
  "emailias.com",
  "emailias.net",
  "emailias.org",
  "emailme.com",
  "emailme.net",
  "emailme.org",
  "emailtemporaneo.com",
  "emailtemporaneo.net",
  "emailtemporaneo.org",
  "emailx.com",
  "emailx.net",
  "emailx.org",
  "ephemeral.com",
  "ephemeral.net",
  "ephemeral.org",
  "fakedetail.com",
  "fakedetail.net",
  "fakedetail.org",
  "fakeinbox.com",
  "fakeinbox.net",
  "fakeinbox.org",
  "freakymail.com",
  "freakymail.net",
  "freakymail.org",
  "freshinbox.com",
  "freshinbox.net",
  "freshinbox.org",
  "getmail.com",
  "getmail.net",
  "getmail.org",
  "gishpuppy.com",
  "gishpuppy.net",
  "gishpuppy.org",
  "gmailninja.com",
  "gmailninja.net",
  "gmailninja.org",
  "gotmail.com",
  "gotmail.net",
  "gotmail.org",
  "ilovemelons.com",
  "ilovemelons.net",
  "ilovemelons.org",
  "inboxclean.com",
  "inboxclean.net",
  "inboxclean.org",
  "junk1.com",
  "junk1.net",
  "junk1.org",
  "junk2.com",
  "junk2.net",
  "junk2.org",
  "junk3.com",
  "junk3.net",
  "junk3.org",
  "junk4.com",
  "junk4.net",
  "junk4.org",
  "junk5.com",
  "junk5.net",
  "junk5.org",
  "junk6.com",
  "junk6.net",
  "junk6.org",
  "junk7.com",
  "junk7.net",
  "junk7.org",
  "junk8.com",
  "junk8.net",
  "junk8.org",
  "junk9.com",
  "junk9.net",
  "junk9.org",
  "junk10.com",
  "junk10.net",
  "junk10.org",
  "junk11.com",
  "junk11.net",
  "junk11.org",
  "junk12.com",
  "junk12.net",
  "junk12.org",
  "junk13.com",
  "junk13.net",
  "junk13.org",
  "junk14.com",
  "junk14.net",
  "junk14.org",
  "junk15.com",
  "junk15.net",
  "junk15.org",
  "junk16.com",
  "junk16.net",
  "junk16.org",
  "junk17.com",
  "junk17.net",
  "junk17.org",
  "junk18.com",
  "junk18.net",
  "junk18.org",
  "junk19.com",
  "junk19.net",
  "junk19.org",
  "junk20.com",
  "junk20.net",
  "junk20.org",
  "junk21.com",
  "junk21.net",
  "junk21.org",
  "junk22.com",
  "junk22.net",
  "junk22.org",
  "junk23.com",
  "junk23.net",
  "junk23.org",
  "junk24.com",
  "junk24.net",
  "junk24.org",
  "junk25.com",
  "junk25.net",
  "junk25.org",
  "junk26.com",
  "junk26.net",
  "junk26.org",
  "junk27.com",
  "junk27.net",
  "junk27.org",
  "junk28.com",
  "junk28.net",
  "junk28.org",
  "junk29.com",
  "junk29.net",
  "junk29.org",
  "junk30.com",
  "junk30.net",
  "junk30.org",
  "junk31.com",
  "junk31.net",
  "junk31.org",
  "junk32.com",
  "junk32.net",
  "junk32.org",
  "junk33.com",
  "junk33.net",
  "junk33.org",
  "junk34.com",
  "junk34.net",
  "junk34.org",
  "junk35.com",
  "junk35.net",
  "junk35.org",
  "junk36.com",
  "junk36.net",
  "junk36.org",
  "junk37.com",
  "junk37.net",
  "junk37.org",
  "junk38.com",
  "junk38.net",
  "junk38.org",
  "junk39.com",
  "junk39.net",
  "junk39.org",
  "junk40.com",
  "junk40.net",
  "junk40.org",
  "junk41.com",
  "junk41.net",
  "junk41.org",
  "junk42.com",
  "junk42.net",
  "junk42.org",
  "junk43.com",
  "junk43.net",
  "junk43.org",
  "junk44.com",
  "junk44.net",
  "junk44.org",
  "junk45.com",
  "junk45.net",
  "junk45.org",
  "junk46.com",
  "junk46.net",
  "junk46.org",
  "junk47.com",
  "junk47.net",
  "junk47.org",
  "junk48.com",
  "junk48.net",
  "junk48.org",
  "junk49.com",
  "junk49.net",
  "junk49.org",
  "junk50.com",
  "junk50.net",
  "junk50.org",
  "junk51.com",
  "junk51.net",
  "junk51.org",
  "junk52.com",
  "junk52.net",
  "junk52.org",
  "junk53.com",
  "junk53.net",
  "junk53.org",
  "junk54.com",
  "junk54.net",
  "junk54.org",
  "junk55.com",
  "junk55.net",
  "junk55.org",
  "junk56.com",
  "junk56.net",
  "junk56.org",
  "junk57.com",
  "junk57.net",
  "junk57.org",
  "junk58.com",
  "junk58.net",
  "junk58.org",
  "junk59.com",
  "junk59.net",
  "junk59.org",
  "junk60.com",
  "junk60.net",
  "junk60.org",
  "junk61.com",
  "junk61.net",
  "junk61.org",
  "junk62.com",
  "junk62.net",
  "junk62.org",
  "junk63.com",
  "junk63.net",
  "junk63.org",
  "junk64.com",
  "junk64.net",
  "junk64.org",
  "junk65.com",
  "junk65.net",
  "junk65.org",
  "junk66.com",
  "junk66.net",
  "junk66.org",
  "junk67.com",
  "junk67.net",
  "junk67.org",
  "junk68.com",
  "junk68.net",
  "junk68.org",
  "junk69.com",
  "junk69.net",
  "junk69.org",
  "junk70.com",
  "junk70.net",
  "junk70.org",
  "junk71.com",
  "junk71.net",
  "junk71.org",
  "junk72.com",
  "junk72.net",
  "junk72.org",
  "junk73.com",
  "junk73.net",
  "junk73.org",
  "junk74.com",
  "junk74.net",
  "junk74.org",
  "junk75.com",
  "junk75.net",
  "junk75.org",
  "junk76.com",
  "junk76.net",
  "junk76.org",
  "junk77.com",
  "junk77.net",
  "junk77.org",
  "junk78.com",
  "junk78.net",
  "junk78.org",
  "junk79.com",
  "junk79.net",
  "junk79.org",
  "junk80.com",
  "junk80.net",
  "junk80.org",
  "junk81.com",
  "junk81.net",
  "junk81.org",
  "junk82.com",
  "junk82.net",
  "junk82.org",
  "junk83.com",
  "junk83.net",
  "junk83.org",
  "junk84.com",
  "junk84.net",
  "junk84.org",
  "junk85.com",
  "junk85.net",
  "junk85.org",
  "junk86.com",
  "junk86.net",
  "junk86.org",
  "junk87.com",
  "junk87.net",
  "junk87.org",
  "junk88.com",
  "junk88.net",
  "junk88.org",
  "junk89.com",
  "junk89.net",
  "junk89.org",
  "junk90.com",
  "junk90.net",
  "junk90.org",
  "junk91.com",
  "junk91.net",
  "junk91.org",
  "junk92.com",
  "junk92.net",
  "junk92.org",
  "junk93.com",
  "junk93.net",
  "junk93.org",
  "junk94.com",
  "junk94.net",
  "junk94.org",
  "junk95.com",
  "junk95.net",
  "junk95.org",
  "junk96.com",
  "junk96.net",
  "junk96.org",
  "junk97.com",
  "junk97.net",
  "junk97.org",
  "junk98.com",
  "junk98.net",
  "junk98.org",
  "junk99.com",
  "junk99.net",
  "junk99.org",
  "junk100.com",
  "junk100.net",
  "junk100.org",
  "junk101.com",
  "junk101.net",
  "junk101.org",
  "junk102.com",
  "junk102.net",
  "junk102.org",
  "junk103.com",
  "junk103.net",
  "junk103.org",
  "junk104.com",
  "junk104.net",
  "junk104.org",
  "junk105.com",
  "junk105.net",
  "junk105.org",
  "junk106.com",
  "junk106.net",
  "junk106.org",
  "junk107.com",
  "junk107.net",
  "junk107.org",
  "junk108.com",
  "junk108.net",
  "junk108.org",
  "junk109.com",
  "junk109.net",
  "junk109.org",
  "junk110.com",
  "junk110.net",
  "junk110.org",
  "junk111.com",
  "junk111.net",
  "junk111.org",
  "junk112.com",
  "junk112.net",
  "junk112.org",
  "junk113.com",
  "junk113.net",
  "junk113.org",
  "junk114.com",
  "junk114.net",
  "junk114.org",
  "junk115.com",
  "junk115.net",
  "junk115.org",
  "junk116.com",
  "junk116.net",
  "junk116.org",
  "junk117.com",
  "junk117.net",
  "junk117.org",
  "junk118.com",
  "junk118.net",
  "junk118.org",
  "junk119.com",
  "junk119.net",
  "junk119.org",
  "junk120.com",
  "junk120.net",
  "junk120.org",
  "junk121.com",
  "junk121.net",
  "junk121.org",
  "junk122.com",
  "junk122.net",
  "junk122.org",
  "junk123.com",
  "junk123.net",
  "junk123.org",
  "junk124.com",
  "junk124.net",
  "junk124.org",
  "junk125.com",
  "junk125.net",
  "junk125.org",
  "junk126.com",
  "junk126.net",
  "junk126.org",
  "junk127.com",
  "junk127.net",
  "junk127.org",
  "junk128.com",
  "junk128.net",
  "junk128.org",
  "junk129.com",
  "junk129.net",
  "junk129.org",
  "junk130.com",
  "junk130.net",
  "junk130.org",
  "junk131.com",
  "junk131.net",
  "junk131.org",
  "junk132.com",
  "junk132.net",
  "junk132.org",
  "junk133.com",
  "junk133.net",
  "junk133.org",
  "junk134.com",
  "junk134.net",
  "junk134.org",
  "junk135.com",
  "junk135.net",
  "junk135.org",
  "junk136.com",
  "junk136.net",
  "junk136.org",
  "junk137.com",
  "junk137.net",
  "junk137.org",
  "junk138.com",
  "junk138.net",
  "junk138.org",
  "junk139.com",
  "junk139.net",
  "junk139.org",
  "junk140.com",
  "junk140.net",
  "junk140.org",
  "junk141.com",
  "junk141.net",
  "junk141.org",
  "junk142.com",
  "junk142.net",
  "junk142.org",
  "junk143.com",
  "junk143.net",
  "junk143.org",
  "junk144.com",
  "junk144.net",
  "junk144.org",
  "junk145.com",
  "junk145.net",
  "junk145.org",
  "junk146.com",
  "junk146.net",
  "junk146.org",
  "junk147.com",
  "junk147.net",
  "junk147.org",
  "junk148.com",
  "junk148.net",
  "junk148.org",
  "junk149.com",
  "junk149.net",
  "junk149.org",
  "junk150.com",
  "junk150.net",
  "junk150.org",
  "junk151.com",
  "junk151.net",
  "junk151.org",
  "junk152.com",
  "junk152.net",
  "junk152.org",
  "junk153.com",
  "junk153.net",
  "junk153.org",
  "junk154.com",
  "junk154.net",
  "junk154.org",
  "junk155.com",
  "junk155.net",
  "junk155.org",
  "junk156.com",
  "junk156.net",
  "junk156.org",
  "junk157.com",
  "junk157.net",
  "junk157.org",
  "junk158.com",
  "junk158.net",
  "junk158.org",
  "junk159.com",
  "junk159.net",
  "junk159.org",
  "junk160.com",
  "junk160.net",
  "junk160.org",
  "junk161.com",
  "junk161.net",
  "junk161.org",
  "junk162.com",
  "junk162.net",
  "junk162.org",
  "junk163.com",
  "junk163.net",
  "junk163.org",
  "junk164.com",
  "junk164.net",
  "junk164.org",
  "junk165.com",
  "junk165.net",
  "junk165.org",
  "junk166.com",
  "junk166.net",
  "junk166.org",
  "junk167.com",
  "junk167.net",
  "junk167.org",
  "junk168.com",
  "junk168.net",
  "junk168.org",
  "junk169.com",
  "junk169.net",
  "junk169.org",
  "junk170.com",
  "junk170.net",
  "junk170.org",
  "junk171.com",
  "junk171.net",
  "junk171.org",
  "junk172.com",
  "junk172.net",
  "junk172.org",
  "junk173.com",
  "junk173.net",
  "junk173.org",
  "junk174.com",
  "junk174.net",
  "junk174.org",
  "junk175.com",
  "junk175.net",
  "junk175.org",
  "junk176.com",
  "junk176.net",
  "junk176.org",
  "junk177.com",
  "junk177.net",
  "junk177.org",
  "junk178.com",
  "junk178.net",
  "junk178.org",
  "junk179.com",
  "junk179.net",
  "junk179.org",
  "junk180.com",
  "junk180.net",
  "junk180.org",
  "junk181.com",
  "junk181.net",
  "junk181.org",
  "junk182.com",
  "junk182.net",
  "junk182.org",
  "junk183.com",
  "junk183.net",
  "junk183.org",
  "junk184.com",
  "junk184.net",
  "junk184.org",
  "junk185.com",
  "junk185.net",
  "junk185.org",
  "junk186.com",
  "junk186.net",
  "junk186.org",
  "junk187.com",
  "junk187.net",
  "junk187.org",
  "junk188.com",
  "junk188.net",
  "junk188.org",
  "junk189.com",
  "junk189.net",
  "junk189.org",
  "junk190.com",
  "junk190.net",
  "junk190.org",
  "junk191.com",
  "junk191.net",
  "junk191.org",
  "junk192.com",
  "junk192.net",
  "junk192.org",
  "junk193.com",
  "junk193.net",
  "junk193.org",
  "junk194.com",
  "junk194.net",
  "junk194.org",
  "junk195.com",
  "junk195.net",
  "junk195.org",
  "junk196.com",
  "junk196.net",
  "junk196.org",
  "junk197.com",
  "junk197.net",
  "junk197.org",
  "junk198.com",
  "junk198.net",
  "junk198.org",
  "junk199.com",
  "junk199.net",
  "junk199.org",
  "junk200.com",
  "junk200.net",
  "junk200.org",
  "junk201.com",
  "junk201.net",
  "junk201.org",
  "junk202.com",
  "junk202.net",
  "junk202.org",
  "junk203.com",
  "junk203.net",
  "junk203.org",
  "junk204.com",
  "junk204.net",
  "junk204.org",
  "junk205.com",
  "junk205.net",
  "junk205.org",
  "junk206.com",
  "junk206.net",
  "junk206.org",
  "junk207.com",
  "junk207.net",
  "junk207.org",
  "junk208.com",
  "junk208.net",
  "junk208.org",
  "junk209.com",
  "junk209.net",
  "junk209.org",
  "junk210.com",
  "junk210.net",
  "junk210.org",
  "junk211.com",
  "junk211.net",
  "junk211.org",
  "junk212.com",
  "junk212.net",
  "junk212.org",
  "junk213.com",
  "junk213.net",
  "junk213.org",
  "junk214.com",
  "junk214.net",
  "junk214.org",
  "junk215.com",
  "junk215.net",
  "junk215.org",
  "junk216.com",
  "junk216.net",
  "junk216.org",
  "junk217.com",
  "junk217.net",
  "junk217.org",
  "junk218.com",
  "junk218.net",
  "junk218.org",
  "junk219.com",
  "junk219.net",
  "junk219.org",
  "junk220.com",
  "junk220.net",
  "junk220.org",
  "junk221.com",
  "junk221.net",
  "junk221.org",
  "junk222.com",
  "junk222.net",
  "junk222.org",
  "junk223.com",
  "junk223.net",
  "junk223.org",
  "junk224.com",
  "junk224.net",
  "junk224.org",
  "junk225.com",
  "junk225.net",
  "junk225.org",
  "junk226.com",
  "junk226.net",
  "junk226.org",
  "junk227.com",
  "junk227.net",
  "junk227.org",
  "junk228.com",
  "junk228.net",
  "junk228.org",
  "junk229.com",
  "junk229.net",
  "junk229.org",
  "junk230.com",
  "junk230.net",
  "junk230.org",
  "junk231.com",
  "junk231.net",
  "junk231.org",
  "junk232.com",
  "junk232.net",
  "junk232.org",
  "junk233.com",
  "junk233.net",
  "junk233.org",
  "junk234.com",
  "junk234.net",
  "junk234.org",
  "junk235.com",
  "junk235.net",
  "junk235.org",
  "junk236.com",
  "junk236.net",
  "junk236.org",
  "junk237.com",
  "junk237.net",
  "junk237.org",
  "junk238.com",
  "junk238.net",
  "junk238.org",
  "junk239.com",
  "junk239.net",
  "junk239.org",
  "junk240.com",
  "junk240.net",
  "junk240.org",
  "junk241.com",
  "junk241.net",
  "junk241.org",
  "junk242.com",
  "junk242.net",
  "junk242.org",
  "junk243.com",
  "junk243.net",
  "junk243.org",
  "junk244.com",
  "junk244.net",
  "junk244.org",
  "junk245.com",
  "junk245.net",
  "junk245.org",
  "junk246.com",
  "junk246.net",
  "junk246.org",
  "junk247.com",
  "junk247.net",
  "junk247.org",
  "junk248.com",
  "junk248.net",
  "junk248.org",
  "junk249.com",
  "junk249.net",
  "junk249.org",
  "junk250.com",
  "junk250.net",
  "junk250.org",
  "junk251.com",
  "junk251.net",
  "junk251.org",
  "junk252.com",
  "junk252.net",
  "junk252.org",
  "junk253.com",
  "junk253.net",
  "junk253.org",
  "junk254.com",
  "junk254.net",
  "junk254.org",
  "junk255.com",
  "junk255.net",
  "junk255.org",
  "junk256.com",
  "junk256.net",
  "junk256.org",
  "junk257.com",
  "junk257.net",
  "junk257.org",
  "junk258.com",
  "junk258.net",
  "junk258.org",
  "junk259.com",
  "junk259.net",
  "junk259.org",
  "junk260.com",
  "junk260.net",
  "junk260.org",
  "junk261.com",
  "junk261.net",
  "junk261.org",
  "junk262.com",
  "junk262.net",
  "junk262.org",
  "junk263.com",
  "junk263.net",
  "junk263.org",
  "junk264.com",
  "junk264.net",
  "junk264.org",
  "junk265.com",
  "junk265.net",
  "junk265.org",
  "junk266.com",
  "junk266.net",
  "junk266.org",
  "junk267.com",
  "junk267.net",
  "junk267.org",
  "junk268.com",
  "junk268.net",
  "junk268.org",
  "junk269.com",
  "junk269.net",
  "junk269.org",
  "junk270.com",
  "junk270.net",
  "junk270.org",
  "junk271.com",
  "junk271.net",
  "junk271.org",
  "junk272.com",
  "junk272.net",
  "junk272.org",
  "junk273.com",
  "junk273.net",
  "junk273.org",
  "junk274.com",
  "junk274.net",
  "junk274.org",
  "junk275.com",
  "junk275.net",
  "junk275.org",
  "junk276.com",
  "junk276.net",
  "junk276.org",
  "junk277.com",
  "junk277.net",
  "junk277.org",
  "junk278.com",
  "junk278.net",
  "junk278.org",
  "junk279.com",
  "junk279.net",
  "junk279.org",
  "junk280.com",
  "junk280.net",
  "junk280.org",
  "junk281.com",
  "junk281.net",
  "junk281.org",
  "junk282.com",
  "junk282.net",
  "junk282.org",
  "junk283.com",
  "junk283.net",
  "junk283.org",
  "junk284.com",
  "junk284.net",
  "junk284.org",
  "junk285.com",
  "junk285.net",
  "junk285.org",
  "junk286.com",
  "junk286.net",
  "junk286.org",
  "junk287.com",
  "junk287.net",
  "junk287.org",
  "junk288.com",
  "junk288.net",
  "junk288.org",
  "junk289.com",
  "junk289.net",
  "junk289.org",
  "junk290.com",
  "junk290.net",
  "junk290.org",
  "junk291.com",
  "junk291.net",
  "junk291.org",
  "junk292.com",
  "junk292.net",
  "junk292.org",
  "junk293.com",
  "junk293.net",
  "junk293.org",
  "junk294.com",
  "junk294.net",
  "junk294.org",
  "junk295.com",
  "junk295.net",
  "junk295.org",
  "junk296.com",
  "junk296.net",
  "junk296.org",
  "junk297.com",
  "junk297.net",
  "junk297.org",
  "junk298.com",
  "junk298.net",
  "junk298.org",
  "junk299.com",
  "junk299.net",
  "junk299.org",
  "junk300.com",
  "junk300.net",
  "junk300.org",
  "junk301.com",
  "junk301.net",
  "junk301.org",
  "junk302.com",
  "junk302.net",
  "junk302.org",
  "junk303.com",
  "junk303.net",
  "junk303.org",
  "junk304.com",
  "junk304.net",
  "junk304.org",
  "junk305.com",
  "junk305.net",
  "junk305.org",
  "junk306.com",
  "junk306.net",
  "junk306.org",
  "junk307.com",
  "junk307.net",
  "junk307.org",
  "junk308.com",
  "junk308.net",
  "junk308.org",
  "junk309.com",
  "junk309.net",
  "junk309.org",
  "junk310.com",
  "junk310.net",
  "junk310.org",
  "junk311.com",
  "junk311.net",
  "junk311.org",
  "junk312.com",
  "junk312.net",
  "junk312.org",
  "junk313.com",
  "junk313.net",
  "junk313.org",
  "junk314.com",
  "junk314.net",
  "junk314.org",
  "junk315.com",
  "junk315.net",
  "junk315.org",
  "junk316.com",
  "junk316.net",
  "junk316.org",
  "junk317.com",
  "junk317.net",
  "junk317.org",
  "junk318.com",
  "junk318.net",
  "junk318.org",
  "junk319.com",
  "junk319.net",
  "junk319.org",
  "junk320.com",
  "junk320.net",
  "junk320.org",
  "junk321.com",
  "junk321.net",
  "junk321.org",
  "junk322.com",
  "junk322.net",
  "junk322.org",
  "junk323.com",
  "junk323.net",
  "junk323.org",
  "junk324.com",
  "junk324.net",
  "junk324.org",
  "junk325.com",
  "junk325.net",
  "junk325.org",
  "junk326.com",
  "junk326.net",
  "junk326.org",
  "junk327.com",
  "junk327.net",
  "junk327.org",
  "junk328.com",
  "junk328.net",
  "junk328.org",
  "junk329.com",
  "junk329.net",
  "junk329.org",
  "junk330.com",
  "junk330.net",
  "junk330.org",
  "junk331.com",
  "junk331.net",
  "junk331.org",
  "junk332.com",
  "junk332.net",
  "junk332.org",
  "junk333.com",
  "junk333.net",
  "junk333.org",
  "junk334.com",
  "junk334.net",
  "junk334.org",
  "junk335.com",
  "junk335.net",
  "junk335.org",
  "junk336.com",
  "junk336.net",
  "junk336.org",
  "junk337.com",
  "junk337.net",
  "junk337.org",
  "junk338.com",
  "junk338.net",
  "junk338.org",
  "junk339.com",
  "junk339.net",
  "junk339.org",
  "junk340.com",
  "junk340.net",
  "junk340.org",
  "junk341.com",
  "junk341.net",
  "junk341.org",
  "junk342.com",
  "junk342.net",
  "junk342.org",
  "junk343.com",
  "junk343.net",
  "junk343.org",
  "junk344.com",
  "junk344.net",
  "junk344.org",
  "junk345.com",
  "junk345.net",
  "junk345.org",
  "junk346.com",
  "junk346.net",
  "junk346.org",
  "junk347.com",
  "junk347.net",
  "junk347.org",
  "junk348.com",
  "junk348.net",
  "junk348.org",
  "junk349.com",
  "junk349.net",
  "junk349.org",
  "junk350.com",
  "junk350.net",
  "junk350.org",
  "junk351.com",
  "junk351.net",
  "junk351.org",
  "junk352.com",
  "junk352.net",
  "junk352.org",
  "junk353.com",
  "junk353.net",
  "junk353.org",
  "junk354.com",
  "junk354.net",
  "junk354.org",
  "junk355.com",
  "junk355.net",
  "junk355.org",
  "junk356.com",
  "junk356.net",
  "junk356.org",
  "junk357.com",
  "junk357.net",
  "junk357.org",
  "junk358.com",
  "junk358.net",
  "junk358.org",
  "junk359.com",
  "junk359.net",
  "junk359.org",
  "junk360.com",
  "junk360.net",
  "junk360.org",
  "junk361.com",
  "junk361.net",
  "junk361.org",
  "junk362.com",
  "junk362.net",
  "junk362.org",
  "junk363.com",
  "junk363.net",
  "junk363.org",
  "junk364.com",
  "junk364.net",
  "junk364.org",
  "junk365.com",
  "junk365.net",
  "junk365.org",
  "junk366.com",
  "junk366.net",
  "junk366.org",
  "junk367.com",
  "junk367.net",
  "junk367.org",
  "junk368.com",
  "junk368.net",
  "junk368.org",
  "junk369.com",
  "junk369.net",
  "junk369.org",
  "junk370.com",
  "junk370.net",
  "junk370.org",
  "junk371.com",
  "junk371.net",
  "junk371.org",
  "junk372.com",
  "junk372.net",
  "junk372.org",
  "junk373.com",
  "junk373.net",
  "junk373.org",
  "junk374.com",
  "junk374.net",
  "junk374.org",
  "junk375.com",
  "junk375.net",
  "junk375.org",
  "junk376.com",
  "junk376.net",
  "junk376.org",
  "junk377.com",
  "junk377.net",
  "junk377.org",
  "junk378.com",
  "junk378.net",
  "junk378.org",
  "junk379.com",
  "junk379.net",
  "junk379.org",
  "junk380.com",
  "junk380.net",
  "junk380.org",
  "junk381.com",
  "junk381.net",
  "junk381.org",
  "junk382.com",
  "junk382.net",
  "junk382.org",
  "junk383.com",
  "junk383.net",
  "junk383.org",
  "junk384.com",
  "junk384.net",
  "junk384.org",
  "junk385.com",
  "junk385.net",
  "junk385.org",
  "junk386.com",
  "junk386.net",
  "junk386.org",
  "junk387.com",
  "junk387.net",
  "junk387.org",
  "junk388.com",
  "junk388.net",
  "junk388.org",
  "junk389.com",
  "junk389.net",
  "junk389.org",
  "junk390.com",
  "junk390.net",
  "junk390.org",
  "junk391.com",
  "junk391.net",
  "junk391.org",
  "junk392.com",
  "junk392.net",
  "junk392.org",
  "junk393.com",
  "junk393.net",
  "junk393.org",
  "junk394.com",
  "junk394.net",
  "junk394.org",
  "junk395.com",
  "junk395.net",
  "junk395.org",
  "junk396.com",
  "junk396.net",
  "junk396.org",
  "junk397.com",
  "junk397.net",
  "junk397.org",
  "junk398.com",
  "junk398.net",
  "junk398.org",
  "junk399.com",
  "junk399.net",
  "junk399.org",
  "junk400.com",
  "junk400.net",
  "junk400.org",
  "junk401.com",
  "junk401.net",
  "junk401.org",
  "junk402.com",
  "junk402.net",
  "junk402.org",
  "junk403.com",
  "junk403.net",
  "junk403.org",
  "junk404.com",
  "junk404.net",
  "junk404.org",
  "junk405.com",
  "junk405.net",
  "junk405.org",
  "junk406.com",
  "junk406.net",
  "junk406.org",
  "junk407.com",
  "junk407.net",
  "junk407.org",
  "junk408.com",
  "junk408.net",
  "junk408.org",
  "junk409.com",
  "junk409.net",
  "junk409.org",
  "junk410.com",
  "junk410.net",
  "junk410.org",
  "junk411.com",
  "junk411.net",
  "junk411.org",
  "junk412.com",
  "junk412.net",
  "junk412.org",
  "junk413.com",
  "junk413.net",
  "junk413.org",
  "junk414.com",
  "junk414.net",
  "junk414.org",
  "junk415.com",
  "junk415.net",
  "junk415.org",
  "junk416.com",
  "junk416.net",
  "junk416.org",
  "junk417.com",
  "junk417.net",
  "junk417.org",
  "junk418.com",
  "junk418.net",
  "junk418.org",
  "junk419.com",
  "junk419.net",
  "junk419.org",
  "junk420.com",
  "junk420.net",
  "junk420.org",
  "junk421.com",
  "junk421.net",
  "junk421.org",
  "junk422.com",
  "junk422.net",
  "junk422.org",
  "junk423.com",
  "junk423.net",
  "junk423.org",
  "junk424.com",
  "junk424.net",
  "junk424.org",
  "junk425.com",
  "junk425.net",
  "junk425.org",
  "junk426.com",
  "junk426.net",
  "junk426.org",
  "junk427.com",
  "junk427.net",
  "junk427.org",
  "junk428.com",
  "junk428.net",
  "junk428.org",
  "junk429.com",
  "junk429.net",
  "junk429.org",
  "junk430.com",
  "junk430.net",
  "junk430.org",
  "junk431.com",
  "junk431.net",
  "junk431.org",
  "junk432.com",
  "junk432.net",
  "junk432.org",
  "junk433.com",
  "junk433.net",
  "junk433.org",
  "junk434.com",
  "junk434.net",
  "junk434.org",
  "junk435.com",
  "junk435.net",
  "junk435.org",
  "junk436.com",
  "junk436.net",
  "junk436.org",
  "junk437.com",
  "junk437.net",
  "junk437.org",
  "junk438.com",
  "junk438.net",
  "junk438.org",
  "junk439.com",
  "junk439.net",
  "junk439.org",
  "junk440.com",
  "junk440.net",
  "junk440.org",
  "junk441.com",
  "junk441.net",
  "junk441.org",
  "junk442.com",
  "junk442.net",
  "junk442.org",
  "junk443.com",
  "junk443.net",
  "junk443.org",
  "junk444.com",
  "junk444.net",
  "junk444.org",
  "junk445.com",
  "junk445.net",
  "junk445.org",
  "junk446.com",
  "junk446.net",
  "junk446.org",
  "junk447.com",
  "junk447.net",
  "junk447.org",
  "junk448.com",
  "junk448.net",
  "junk448.org",
  "junk449.com",
  "junk449.net",
  "junk449.org",
  "junk450.com",
  "junk450.net",
  "junk450.org",
  "junk451.com",
  "junk451.net",
  "junk451.org",
  "junk452.com",
  "junk452.net",
  "junk452.org",
  "junk453.com",
  "junk453.net",
  "junk453.org",
  "junk454.com",
  "junk454.net",
  "junk454.org",
  "junk455.com",
  "junk455.net",
  "junk455.org",
  "junk456.com",
  "junk456.net",
  "junk456.org",
  "junk457.com",
  "junk457.net",
  "junk457.org",
  "junk458.com",
  "junk458.net",
  "junk458.org",
  "junk459.com",
  "junk459.net",
  "junk459.org",
  "junk460.com",
  "junk460.net",
  "junk460.org",
  "junk461.com",
  "junk461.net",
  "junk461.org",
  "junk462.com",
  "junk462.net",
  "junk462.org",
  "junk463.com",
  "junk463.net",
  "junk463.org",
  "junk464.com",
  "junk464.net",
  "junk464.org",
  "junk465.com",
  "junk465.net",
  "junk465.org",
  "junk466.com",
  "junk466.net",
  "junk466.org",
  "junk467.com",
  "junk467.net",
  "junk467.org",
  "junk468.com",
  "junk468.net",
  "junk468.org",
  "junk469.com",
  "junk469.net",
  "junk469.org",
  "junk470.com",
  "junk470.net",
  "junk470.org",
  "junk471.com",
  "junk471.net",
  "junk471.org",
  "junk472.com",
  "junk472.net",
  "junk472.org",
  "junk473.com",
  "junk473.net",
  "junk473.org",
  "junk474.com",
  "junk474.net",
  "junk474.org",
  "junk475.com",
  "junk475.net",
  "junk475.org",
  "junk476.com",
  "junk476.net",
  "junk476.org",
  "junk477.com",
  "junk477.net",
  "junk477.org",
  "junk478.com",
  "junk478.net",
  "junk478.org",
  "junk479.com",
  "junk479.net",
  "junk479.org",
  "junk480.com",
  "junk480.net",
  "junk480.org",
  "junk481.com",
  "junk481.net",
  "junk481.org",
  "junk482.com",
  "junk482.net",
  "junk482.org",
  "junk483.com",
  "junk483.net",
  "junk483.org",
  "junk484.com",
  "junk484.net",
  "junk484.org",
  "junk485.com",
  "junk485.net",
  "junk485.org",
  "junk486.com",
  "junk486.net",
  "junk486.org",
  "junk487.com",
  "junk487.net",
  "junk487.org",
  "junk488.com",
  "junk488.net",
  "junk488.org",
  "junk489.com",
  "junk489.net",
  "junk489.org",
  "junk490.com",
  "junk490.net",
  "junk490.org",
  "junk491.com",
  "junk491.net",
  "junk491.org",
  "junk492.com",
  "junk492.net",
  "junk492.org",
  "junk493.com",
  "junk493.net",
  "junk493.org",
  "junk494.com",
  "junk494.net",
  "junk494.org",
  "junk495.com",
  "junk495.net",
  "junk495.org",
  "junk496.com",
  "junk496.net",
  "junk496.org",
  "junk497.com",
  "junk497.net",
  "junk497.org",
  "junk498.com",
  "junk498.net",
  "junk498.org",
  "junk499.com",
  "junk499.net",
  "junk499.org",
  "junk500.com",
  "junk500.net",
  "junk500.org",
]);

export function sanitizeText(input: string): string {
  if (typeof input !== "string") return "";
  return input
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "")
    .replace(/javascript\s*:/gi, "")
    .trim();
}

/**
 * Non-escaping sanitizer for content that will be rendered with
 * ReactMarkdown / KaTeX. It strips dangerous script/iframe/object markup,
 * inline event handlers and `javascript:`/`vbscript:`/`data:text/html`
 * URLs, but it deliberately leaves `< > " ' :` intact — React already
 * escapes_text, and re-encoding those chars (as the strict `sanitizeInput`
 * does) is what produces the `&quot;` / `&lt;` the_user_sees_in_answers,
 * notes and LaTeX. Use this for any markdown / math payload.
 */
export function sanitizeForMarkdown(input: string): string {
  if (typeof input !== "string") return "";
  return input
    .replace(/\x00/g, "")
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "")
    .replace(/<svg\b[^<]*(?:(?!<\/svg>)<[^<]*)*<\/svg>/gi, "")
    .replace(/<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi, "")
    .replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, "")
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "")
    .replace(/<base\b[^<]*(?:(?!<\/base>)<[^<]*)*<\/base>/gi, "")
    .replace(/<form\b[^<]*(?:(?!<\/form>)<[^<]*)*<\/form>/gi, "")
    .replace(/<img\b[^<]*(?:(?!<\/img>)<[^<]*)*>/gi, "")
    .replace(/on\w+\s*=\s*["'][^"']*["']/gi, "")
    .replace(/on\w+\s*=\s*\S+/gi, "")
    .replace(/javascript\s*:/gi, "")
    .replace(/vbscript\s*:/gi, "")
    .replace(/data\s*:\s*text\/html/gi, "")
    .trim();
}

/**
 * Decode HTML entities that may have been persisted in stored content
 * (e.g. &quot; &lt; &gt; &amp; &#39;). Apply BEFORE feeding text into
 * ReactMarkdown/KaTeX so already-mangled content renders correctly.
 */
export function decodeEntities(input: string): string {
  if (typeof input !== "string") return "";
  return input
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#039;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&#x27;/g, "'")
    .replace(/&#x2F;/g, "/")
    .replace(/&amp;/g, "&");
}

export function sanitizeEmail(email: string): string {
  return email.replace(/[<>]/g, "").trim().toLowerCase();
}

export function sanitizePhone(phone: string): string {
  return phone.replace(/[^\d+()\-.\s]/g, "").trim();
}

export function sanitizeUrl(url: string): string {
  try {
    const parsed = new URL(url);
    if (!["http:", "https:", "mailto:"].includes(parsed.protocol)) return "";
    if (parsed.protocol === "javascript:") return "";
    return parsed.toString();
  } catch {
    return "";
  }
}

export function sanitizeInput(input: string): string {
  if (typeof input !== "string") return "";
  if (input.length > 1024 * 1024) {
    // Truncate inputs > 1MB to prevent hanging UI
    input = input.slice(0, 1024 * 1024);
  }
  return input
    .replace(/\x00/g, "")
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "")
    .replace(/<svg\b[^<]*(?:(?!<\/svg>)<[^<]*)*<\/svg>/gi, "")
    .replace(/<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi, "")
    .replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, "")
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "")
    .replace(/<base\b[^<]*(?:(?!<\/base>)<[^<]*)*<\/base>/gi, "")
    .replace(/<form\b[^<]*(?:(?!<\/form>)<[^<]*)*<\/form>/gi, "")
    .replace(/on\w+\s*=\s*["'][^"']*["']/gi, "")
    .replace(/on\w+\s*=\s*\S+/gi, "")
    .replace(/javascript\s*:/gi, "")
    .replace(/vbscript\s*:/gi, "")
    .replace(/data\s*:\s*text\/html/gi, "")
    .trim();
}

export function isDisposableEmail(email: string): boolean {
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return true;
  return DISPOSABLE_DOMAINS.has(domain);
}

export function validateEmailForAuth(email: string): {
  valid: boolean;
  error?: string;
} {
  const trimmed = email.trim().toLowerCase();
  if (!trimmed) return { valid: false, error: "Email is required." };
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed))
    return { valid: false, error: "Enter a valid email address." };
  if (isDisposableEmail(trimmed))
    return {
      valid: false,
      error:
        "Temporary email addresses are not allowed. Use your institutional email.",
    };
  return { valid: true };
}

/**
 * Detects garbled / non-meaningful input that would silently fail or
 * produce nonsense results. Returns a human-readable reason string when
 * the input is garbled, or `null` when the input looks valid.
 *
 * Checks:
 *  - Empty or whitespace-only
 *  - Less than 3 visible characters after trim
 *  - Repetitive character spam (e.g. "aaaaaa", "1234567890123456")
 *  - Excessive symbol/emoji ratio (more symbols than alphanumeric)
 *  - Control characters (other than newlines/tabs)
 */
export function detectGarbledInput(input: string): string | null {
  if (typeof input !== "string") return "Input is not a string.";
  const trimmed = input.trim();

  if (!trimmed) return "Please enter a question to continue.";
  if (trimmed.length < 3)
    return "That's too short — please provide at least 3 characters.";

  // Strip newlines/tabs for character analysis
  const noWhitespace = trimmed.replace(/\s/g, "");

  if (noWhitespace.length < 2)
    return "Please enter a more descriptive question.";

  // Detect run-on repetition (e.g. "aaaa", "111111111", "aaaaaaaaaaa")
  // Flag if a single character repeats more than 70% of the string and
  // the string is at least 5 chars long.
  if (noWhitespace.length >= 5) {
    const charCounts = new Map<string, number>();
    for (const ch of noWhitespace) {
      charCounts.set(ch, (charCounts.get(ch) ?? 0) + 1);
    }
    const maxFreq = Math.max(...charCounts.values());
    if (maxFreq / noWhitespace.length > 0.7) {
      return "Input looks like repeated characters — please type a real question.";
    }
  }

  // Detect excessive symbol/emoji ratio.
  // Count "real" alphanumeric characters vs everything else.
  const alnumCount = (
    noWhitespace.match(/[a-zA-Z0-9\u0600-\u06FF\u0660-\u0669]/g) || []
  ).length;
  const totalVisible = noWhitespace.length;
  const symbolRatio = (totalVisible - alnumCount) / totalVisible;

  // If less than 30% of characters are alphanumeric and we have > 4 chars,
  // the input is likely garbled (symbols/emojis only)
  if (totalVisible > 4 && symbolRatio > 0.7 && alnumCount < 3) {
    return "Input appears to be symbols only — please type your question in words.";
  }

  // Detect control characters (excluding common whitespace)
  // C0 controls except \t \n \r, and C1 controls
  if (
    /[\x00-\x08\x0b\x0c\x0e-\x1f\x7f-\x9f]/.test(trimmed) &&
    !/^[\s\u0600-\u06FF\u0660-\u0669]+$/.test(trimmed)
  ) {
    return "Input contains invalid control characters.";
  }

  return null;
}
